import Tasks from 'APP/Tasks';
import { GroupType, GroupUserRole } from 'APP/model/group/groupModel.types';
import { IScheduledMessage } from 'APP/model/message/messageModel.types';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';
import { IStrangeServerGroup } from 'STORE/Groups/types';

const SCHEDULED_MESSAGE_LIMIT = 100;

interface IGetAllScheduledMessages {
  groupId: string;
  messages?: IScheduledMessage[];
  cursor?: string;
}

export const getAllScheduledMessages = async (
  data: IGetAllScheduledMessages
): Promise<IScheduledMessage[]> => {
  const result = await messageModel.getGroupScheduledMessages(
    data.groupId,
    SCHEDULED_MESSAGE_LIMIT,
    data.cursor
  );
  if (result.nextCursor) {
    return await getAllScheduledMessages({
      groupId: data.groupId,
      messages: [...(data.messages || []), ...result.messages],
      cursor: result.nextCursor,
    });
  }
  return [...(data.messages || []), ...result.messages];
};

// TODO: remove this code after scheduled messages refactoring: GEM-23214
export function createScheduledGroup(group: Group): Group | null {
  const scheduleGroup = Entities.GroupsStore.getGroupById(group.scheduleGroupId);
  if (scheduleGroup) {
    return scheduleGroup;
  }

  const data: IStrangeServerGroup = {
    id: group.scheduleGroupId,
    groupId: group.id,
    type: GroupType.Schedule,
    userGroupRole: GroupUserRole.Owner,
  };

  Entities.GroupsStore.merge([data]);

  return Entities.GroupsStore.getGroupById(group.scheduleGroupId);
}

export async function loadScheduledMessages(groupId: string): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(groupId);

  if (
    !group ||
    !group.canBeScheduled ||
    group.isSheduledMessagesLoading ||
    Entities.GroupsStore.getGroupById(group.scheduleGroupId)
  ) {
    return;
  }

  try {
    group.isSheduledMessagesLoading = true;

    const messages = await getAllScheduledMessages({ groupId });
    createScheduledGroup(group);

    Tasks.messaging.updateScheduledMessages(groupId, messages);
  } catch {
    //
  }

  group.isSheduledMessagesLoading = false;
}
